<script>
  import { onMount } from "svelte";
  import LandingHeader from "../components/LandingHeader.svelte";
  import ProtectedRoute from "../components/ProtectedRoute.svelte";

  let subscribers = [];
  let errorMessage = "";
  let userData = null;

  onMount(() => {
    userData = JSON.parse(localStorage.getItem("userData"));
  });

  onMount(async () => {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/subscribe/subscribers/${userData.user._id}?_=${Date.now()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: userData.token,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch subscribers");
      }

      subscribers = await response.json();
    } catch (error) {
      console.error("Error fetching subscribers:", error);
      errorMessage = error.message;
    }
  });
</script>

<ProtectedRoute>
  <main>
    <LandingHeader />
    <div class="title">
      <span class="title-span">Subscribers</span>
    </div>

    <!-- {#if errorMessage}
      <p class="error">{errorMessage}</p>
    {/if} -->

    <div class="subscribers">
      {#if subscribers.length > 0}
        <table class="subscriber-table">
          <thead>
            <tr>
              <th>Subscribers</th>
              <!-- <th>Email</th> -->
            </tr>
          </thead>
          <tbody>
            {#each subscribers as subscriber}
              <tr class="subscriber-row">
                <td class="profile-cell">
                  <img
                    class="profile-picture"
                    src={subscriber.profilePicture || "/profile.png"}
                    alt={`${subscriber.name}'s profile picture`}
                  />
                  <span class="username">{subscriber.name}</span>
                </td>
                <!-- <td>{subscriber.email}</td> -->
              </tr>
            {/each}
          </tbody>
        </table>
      {:else}
        <p>No subscribers found.</p>
      {/if}
    </div>
  </main>
</ProtectedRoute>

<style>
  .title {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 10px;
    box-shadow: 0 4px 8px rgba(135, 135, 135, 0.1);
    /* background: linear-gradient(to bottom, #FF3C82 45%, #1e92ff 55%); */
    /* background: linear-gradient(130deg, #cdb4db, #ffffff);
      box-shadow:
        inset -20px 0 50px #cdb4db,
        inset 20px 0 50px #cdb4db; */
  }

  .title-span {
    margin-top: 5px;
    /* border: 2px solid #000000; */
    border-radius: 25%;
    /* margin: 0 15px; */
    padding: 5px;
    font-size: 1.2rem;
    color: #000000;
    /* text-decoration: underline; */
    /* cursor: pointer; */
    font-size: 1.4rem;
    font-weight: bold;
  }

  .subscribers {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
  }

  .subscriber-table {
    width: 65%;
    border-collapse: collapse;
    text-align: left;
  }

  .subscriber-table th,
  .subscriber-table td {
    padding: 1rem;
    border: 1px solid #ddd;
  }

  .subscriber-row {
    vertical-align: middle;
  }

  .profile-cell {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .profile-picture {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 50%;
  }

  .username {
    font-size: 1rem;
    font-weight: bold;
  }

  .error {
    color: red;
    margin-top: 0.5rem;
    text-align: center;
  }

  @media (max-width: 768px) {
    .title {
      padding: 10px 20px;
    }

    .title-span {
      font-size: 1.2rem;
    }

    .profile-picture {
      width: 30px;
      height: 30px;
    }

    .username {
      font-size: 0.8rem;
    }

    .subscriber-table {
      width: 75%;
    }

    .subscriber-table th,
    .subscriber-table td {
      padding: 0.5rem;
    }
  }

  @media screen and (min-width: 768px) {
    .title {
      margin-top: 40px;
    }
  }

  @media screen and (min-width: 850px) {
    .title {
      margin-top: 5px;
    }
  }

  @media screen and (min-width: 850px) and (min-height: 1280px) {
    .title {
      margin-top: 55px;
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1024px) and (max-height: 600px) {
    .title {
      margin-top: 5px;
    }
  }

  @media screen and (min-width: 1024px) and (min-height: 1300px) {
    .title {
      margin-top: 60px;
    }
  }

  @media screen and (min-width: 1440px) {
    .title {
      margin-top: 20px;
    }
  }
</style>
